import { translate } from "app/filters/i18nFilter";
import { changeFilter } from "app/filters/ngFilters";
import { pureNumberFilter } from "app/filters/numberFilter";
import { FORMATTERS } from "app/common/benchmark/formatters";

import type { WidgetsConfigSchema } from "./types";
import { WidgetType } from "./types";

const HOME_TRANSLATE_PATH = "activation.home";
export const EMPTY_DATA = "N/A";
export const GA_SOURCE = "GA";
export const SW_SOURCE = "SW";
export const WIDGET_ORDER_STORAGE_KEY = "widgetGAOrder";
export const DELAY_FOR_WIDGETS_SAVE = 1000;

const withNull = (val: number | null | undefined, formatter: (num: number) => string) =>
    val == null || val === 0 ? EMPTY_DATA : formatter(val);

const percentFilter = (val: number) => changeFilter()(val, 0);

const commonPercentFormatter = (val) => {
    const percent = withNull(val, percentFilter);

    if (percent !== "-") {
        return percent.replace("-", "");
    }

    return percent;
};

const pagesPerVisitsFilter = (val) => pureNumberFilter(val, "0.00");

export const METRIC_NAMES = {
    TOTAL_VISITS: "totalVisits",
    VISITS_DURATION: "visitsDuration",
    BOUNCE_RATE: "bounceRate",
    PAGES_PER_VISITS: "pagesPerVisit",
    DEVICE_DISTRIBUTION: "deviceDistribution",
    UNIQUE_VISITORS: "uniqueVisitors",
    PAGE_VIEWS: "pageViews",
};

export const getWidgetsConfig = (): WidgetsConfigSchema => ({
    [METRIC_NAMES.TOTAL_VISITS]: {
        title: translate(`${HOME_TRANSLATE_PATH}.totalVisits`),
        icon: "month",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.totalVisits`),
        type: WidgetType.Graph,
        valueFormatter: (val: number | null) => withNull(val, FORMATTERS.numberAbbr),
        changeFormatter: commonPercentFormatter,
    },
    [METRIC_NAMES.VISITS_DURATION]: {
        title: translate(`${HOME_TRANSLATE_PATH}.visitDuration`),
        icon: "avg-visit-duration",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.visitDuration`),
        type: WidgetType.Graph,
        valueFormatter: FORMATTERS.time,
        changeFormatter: commonPercentFormatter,
    },
    [METRIC_NAMES.BOUNCE_RATE]: {
        title: translate(`${HOME_TRANSLATE_PATH}.bounceRate`),
        icon: "bounce-rate-2",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.bounceRate`),
        type: WidgetType.Graph,
        valueFormatter: commonPercentFormatter,
        changeFormatter: commonPercentFormatter,
    },
    [METRIC_NAMES.PAGES_PER_VISITS]: {
        title: translate(`${HOME_TRANSLATE_PATH}.pagesPerVisit`),
        icon: "pages-per-visit",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.pagesPerVisit`),
        type: WidgetType.Graph,
        valueFormatter: (val) => withNull(val, pagesPerVisitsFilter),
        changeFormatter: commonPercentFormatter,
    },
    [METRIC_NAMES.DEVICE_DISTRIBUTION]: {
        title: translate(`${HOME_TRANSLATE_PATH}.deviceDistribution`),
        icon: "combined",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.deviceDistribution`),
        type: WidgetType.Pie,
        valueFormatter: (val: number | null) => withNull(val, FORMATTERS.numberAbbr),
    },
    [METRIC_NAMES.UNIQUE_VISITORS]: {
        title: translate(`${HOME_TRANSLATE_PATH}.uniqueVisitors`),
        icon: "monthly-unique-visitors",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.uniqueVisitors`),
        type: WidgetType.Graph,
        valueFormatter: (val: number | null) => withNull(val, FORMATTERS.numberAbbr),
        changeFormatter: commonPercentFormatter,
    },
    [METRIC_NAMES.PAGE_VIEWS]: {
        title: translate(`${HOME_TRANSLATE_PATH}.pageViews`),
        icon: "pages-per-visit",
        tooltipText: translate(`${HOME_TRANSLATE_PATH}.tooltip.pageViews`),
        type: WidgetType.Graph,
        valueFormatter: (val: number | null) => withNull(val, FORMATTERS.numberAbbr),
        changeFormatter: commonPercentFormatter,
    },
});
